import { Shark } from "shark-mvc";
import moment from "moment";

import BaseContent from "./BaseContent";
import ImageExifData from "./ImageExifData";

class ImageContent extends BaseContent {
	creationDate = "0000-00-00 00:00:00";
	description = "";
	fileByteSize = 0;
	fileIntrinsicHeight = 0;
	fileIntrinsicWidth = 0;
	fileThumbnailURL = "";
	fileType = "";
	fileURL = "";
	originalExifData = {};
	originalFileName = "";
	originalImageInfo = {
		authorName: "",
		fileByteSize: 0,
		height: 0,
		width: 0,
	};
	shootDate = "0000-00-00 00:00:00";
	source = "";
	type = "image";
	
	__descriptionAbstract = "";
	__fileIconURL = "";
	__fileSizeLabel = "";
	__fileIntrinsicHeightLabel = "";
	__fileIntrinsicWidthLabel = "";
	__creationDate = "";
	__creationDateLabel = "";
	__shootDate = "";
	__shootDateLabel = "";

	_mainEditorField = "description";

	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		exportData.originalExifData = JSON.stringify(this.originalExifData?.export()) || this.exportObjectField("originalExifData");
		exportData.originalImageInfo = this.exportObjectField("originalImageInfo");
		exportData.creationDate = this.exportDateField("creationDate");
		exportData.shootDate = this.exportDateField("shootDate");
		
		return exportData;
	}

	import (data, options) {
		super.import(data, options);

		if (this.importDateField("creationDate", data.creationDate)) {
			this.__creationDate = this.creationDate.format("YYYY-MM-DD");
			this.__creationDateLabel = this.creationDate.format("DD/MM/YYYY");
		}

		if (data.originalExifData) {
			this.originalExifData = new ImageExifData(data.originalExifData);
		}

		if (this.importDateField("shootDate", data.shootDate)) {
			this.__shootDate = this.shootDate.format("YYYY-MM-DD");
			this.__shootDateLabel = this.shootDate.format("DD/MM/YYYY");
		}

		this.__fileIconURL = this.fileThumbnailURL.replace("_tmb.jp", "_ico.jp");

		this.parseDescription();
		this.parseFileByteSize();
		this.parseFileIntrinsicHeight();
		this.parseFileIntrinsicWidth();
	}

	on__creationDateChanged () {
		this.creationDate = moment(this.__creationDate);
		this.__creationDateLabel = this.creationDate.format("DD/MM/YYYY");
	}

	on__exifCreationDateChanged () {
		this.creationDate = moment(this.__exifCreationDate, "YYYYY:MM:DD HH:mm:ss");
		this.__creationDate = this.creationDate.format("YYYY-MM-DD");
		this.__creationDateLabel = this.creationDate.format("DD/MM/YYYY");
	}

	on__shootDateChanged () {
		this.shootDate = moment(this.__shootDate);
		this.__shootDateLabel = this.shootDate.format("DD/MM/YYYY");
	}

	onDescriptionChanged () {
		this.parseDescription();
	}

	onFileByteSizeChanged () {
		this.parseFileByteSize();
	}

	onFileIntrinsicHeightChanged () {
		this.parseFileIntrinsicHeight();
	}

	onFileIntrinsicWidthChanged () {
		this.parseFileIntrinsicWidth();
	}

	onOriginalImageInfo_heightChanged () {
		this.parseFileIntrinsicHeight();
	}

	onOriginalImageInfo_widthChanged () {
		this.parseFileIntrinsicWidth();
	}

	onOriginalImageInfoChanged () {
		this.parseFileByteSize();
		this.parseFileIntrinsicHeight();
		this.parseFileIntrinsicWidth();
	}

	onExtraData_permissions_marketingChanged () {
		console.log(this);
	}
	parseDescription () {
		// this.__descriptionAbstract = this.description.length > 35 ? this.description.slice(0, 35) + "..." : this.description;
		const htmlStrippedDescription = this.description.replace(/<[^>]*>/g, "");
		this.__descriptionAbstract = htmlStrippedDescription.length > 50 ? htmlStrippedDescription.slice(0, 50) + "..." : htmlStrippedDescription;
	}

	parseFileByteSize () {
		this.__fileSizeLabel = Shark.$store.numberFormatter.format(this.fileByteSize / 1024 / 1024) + "MB";
		this.__originalFileSizeLabel = Shark.$store.numberFormatter.format(this.originalImageInfo.fileByteSize / 1024 / 1024) + "MB";
	}

	parseFileIntrinsicHeight () {
		this.__fileIntrinsicHeightLabel = Shark.$store.numberFormatter.format(this.fileIntrinsicHeight) + "px";
		this.__originalFileIntrinsicHeightLabel = Shark.$store.numberFormatter.format(this.originalImageInfo.height) + "px";
	}

	parseFileIntrinsicWidth () {
		this.__fileIntrinsicWidthLabel = Shark.$store.numberFormatter.format(this.fileIntrinsicWidth) + "px";
		this.__originalFileIntrinsicWidthLabel = Shark.$store.numberFormatter.format(this.originalImageInfo.width) + "px";
	}
}

Shark.registerModel("ImageContent", ImageContent);

export default ImageContent;